import { Strong } from 'braid-design-system';

export const HighlightedText = ({
  children: text,
  searchFilter,
}: {
  children: string;
  searchFilter?: string;
}) => {
  const lowercaseText = text.toLocaleLowerCase();

  if (!searchFilter || !lowercaseText.includes(searchFilter)) {
    return <>{text}</>;
  }

  // Dice the string in to pieces
  const matchStartIndex = lowercaseText.indexOf(searchFilter);
  const matchEndIndex = matchStartIndex + searchFilter.length;

  const initialPiece = text.slice(0, matchStartIndex);
  const middlePiece = text.slice(matchStartIndex, matchEndIndex);
  const finalPiece = text.slice(matchEndIndex);

  return (
    <>
      {initialPiece}
      <Strong>{middlePiece}</Strong>
      {finalPiece}
    </>
  );
};
